import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Theme before first paint — reading localStorage after render flashes the
// wrong theme for a frame on every load.
try {
  const stored = localStorage.getItem('theme');
  if (stored === 'light') document.documentElement.classList.remove('dark');
} catch {
  /* default (dark) stands */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
